/**
 * @file 文档搜索页列表
 * @author FengGuang(fengguang01@baidu.com)
 */

import React from 'react';
import {ISearchItem} from '../../type';
import SearchdocItem from './SearchdocItem';

interface IProps {
    searchResultList: ISearchItem[]
    onSearchItemClick?: (item: ISearchItem, index: number) => void;
}

const SearchdocList: React.FC<IProps> = props => {
    const {
        searchResultList,
        onSearchItemClick
    } = props;

    return (
        <div className="paddle-searchall-list">
            {searchResultList.map((item, index) => (
                <SearchdocItem
                    key={`${item.title},${item.path},${item.content}`}
                    item={item}
                    index={index}
                    onClick={onSearchItemClick}
                />
            ))}
        </div>
    );
};

export default SearchdocList;
